import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import * as kApi from "../../../../constants/api";

const TermsAndPrivacyLinks = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ margin: "25px 0px 15px" }}>
      {t("global.by_clicking_next_you_agree_to_our")}
      <a
        target="_blank"
        rel="noopener noreferrer"
        title={t("global.use_terms")}
        href={kApi.STATIC_FILE_USE_TERMS}
      >
        <span>{t("global.terms_of_use") + " "}</span>
      </a>
      {t("global.and") + " "}
      <a
        target="_blank"
        rel="noopener noreferrer"
        title={t("global.priv_politics")}
        href={kApi.STATIC_FILE_PRIV_POLITICS}
      >
        {t("global.terms_of_privacy")}
      </a>
    </Box>
  );
};

export default TermsAndPrivacyLinks;
